import {
  UserProfileUpdateDocument,
  UserProfileUpdateMutationResult,
  UserProfileUpdateMutationVariables,
} from "@graphql/api";

interface UpdatedFields {
  contact: {
    name?: String;
    address?: String;
    city?: String;
    state?: String;
    zipCode?: String;
    emailAddress?: String;
    telephone?: String;
    telephone2?: String;
    newPassword?: String;
  };
  linkedReservations?: Array<string>;
}

export default async function userProfileUpdate(
  id: number,
  updatedFields: UpdatedFields
): Promise<boolean> {
  const client = global.window.apolloClient;

  const mutVars: UserProfileUpdateMutationVariables = { id, updatedFields };
  const result: UserProfileUpdateMutationResult = await client.mutate({
    mutation: UserProfileUpdateDocument,
    variables: mutVars,
  });

  if (result.data?.userProfileUpdate.success) {
    // Reload the Apollo cache.
    await client.resetStore();
  }

  return result.data?.userProfileUpdate.success;
}
